
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1429_11789)","stroke":"#fff","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M4.167 5.833L3.15 6.51c-.728.486-1.092.729-1.29 1.099-.197.37-.195.805-.192 1.675.003 1.047.013 2.115.04 3.194.064 2.563.096 3.844 1.038 4.786.942.942 2.24.974 4.837 1.04 1.616.04 3.217.04 4.832 0 2.597-.066 3.895-.098 4.837-1.04.942-.942.974-2.223 1.038-4.785.027-1.08.037-2.148.04-3.195.003-.87.005-1.305-.192-1.675-.198-.37-.562-.613-1.29-1.099l-1.015-.677","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M1.667 8.333l5.76 3.457c1.254.752 1.88 1.128 2.573 1.128.692 0 1.32-.376 2.572-1.128l5.761-3.457","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M4.167 10V5c0-1.571 0-2.357.488-2.845s1.274-.488 2.845-.488h5c1.571 0 2.357 0 2.845.488s.488 1.274.488 2.845v5"}}),_c('path',{attrs:{"d":"M8.333 8.333h3.334M8.333 5h3.334","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1429_11789"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    